<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-end">
        <b-button variant="primary" size="lg" :disabled="!team.name || !users.length" @click="saveTeam" v-if="isCommonAdmin">
          {{ 'save' | i18n }}
        </b-button>
      </div>
      <div class="row poppins">
        <div class="col-12">
          <div class="table-wrapper" style="position: relative">
            <!-- <div class="small-id-text">ID: {{ this.$route.params.id }}</div> -->
            <Loader v-if="!teamLoaded" />
            <div v-else>
              <div>
                <BlockHeader name="Details" />
                <div class="row">
                  <div class="col-lg-6 col-sm-12 col-xs-12">
                    <Input v-model="team.name" form-group-id="name" placeholder="name" />
                  </div>
                  <div class="col-lg-6 col-sm-12 col-xs-12">
                    <Input v-model="team.description" form-group-id="description" placeholder="description" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
                    <Multiselect
                      :options="userOptions"
                      :init-values="users"
                      form-group-id="users"
                      placeholder="users"
                      :on-change="(v) => (users = v)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin, NavigationMixin } from '../../../../mixins';
import BlockHeader from '../../common/block-header';

import Loader from '../../common/loader';
import Input from '../../common/input';
import Multiselect from '../../common/multiselect';

export default {
  title: 'Team Details',
  components: { Loader, BlockHeader, Input, Multiselect },
  mixins: [ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin, NavigationMixin],
  data() {
    return {
      teamLoaded: false,
      team: {},
      userOptions: [],
      users: [],
    };
  },
  async created() {
    await this.getTeam();
  },
  methods: {
    async saveTeam() {
      try {
        const payload = {
          name: this.team.name,
          description: this.team.description,
          userIds: this.users.map((i) => i.value),
        };

        await this.reportsService.updateTeam(this.$route.params.id, payload);
        this.showNotification({ type: 'success', message: this.$translate('success') });
        this.goBack();
      } catch (err) {
        this.showNotification({ type: 'error', message: this.$translate(err.message) });
      }
    },
    async getTeam() {
      try {
        this.teamLoaded = false;
        const responseTeam = await this.reportsService.getTeamByID(this.$route.params.id);
        this.team = responseTeam.data;
        this.users = responseTeam.data.users.map((item) => ({ value: item.id, text: `${item.email} (${item.name})` }));

        const response = await this.reportsService.getUsersLookup();
        this.userOptions = response.data.map((item) => ({ value: item.id, text: `${item.email} (${item.username})` }));

        this.teamLoaded = true;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">


::v-deep .ve-table-body {
  ::v-deep th {
    color: rgb(112, 112, 112) !important;
    background-color: rgb(239, 239, 239) !important;
    border: none !important;
    min-height: 50px;
  }
  ::v-deep td {
    color: rgb(112, 112, 112) !important;
    cursor: pointer;
  }
}

::v-deep .ve-table-cell-selection {
  border: none !important;
}

::v-deep .ve-table-sort {
  top: -4.5px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  margin: auto;
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.date-range-block {
  min-width: 350px;
  text-align: center;
  margin-left: 30px;
  display: flex;
  align-items: center;
}

::v-deep .ve-select-selected-span {
  font-weight: 400;
}

.pagination-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
}

.action-block {
  display: flex;
}
.inputs-block {
  padding-left: 20px;
  padding-right: 20px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
